"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useHomePageHotTips;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _usePopulateProductHref = _interopRequireDefault(require("../../../app/AppSettingsProvider/usePopulateProductHref"));

var _useHomePageHotTipsServiceCall = _interopRequireDefault(require("./useHomePageHotTipsServiceCall"));

function useHomePageHotTips(id) {
  var _React$useState = _react.default.useState(null),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var getProducts = (0, _useHomePageHotTipsServiceCall.default)();
  var populateProductHref = (0, _usePopulateProductHref.default)();

  _react.default.useEffect(function () {
    getProducts().then(function (p) {
      return setState(populateProductHref(p));
    });
    return undefined;
  }, [getProducts, id, populateProductHref, setState]);

  return state || [];
}